import React from "react";
import classnames from "classnames";
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

import usexAPI from "store/customHooks/usexAPI";
import { getUrlPathnameAndSearch } from "utils/url";

import LogobarWrapper from "components/gnb/content/util/LogobarWrapper";
import CloseButton from "components/gnb/content/util/CloseButton";
import gnbInfo from "components/gnb/util/structure";
import { xAPI_ID_VALUE } from "utils/xAPI_PATH";
import { setXAPIPath } from "utils/localStorage";

function FirstDepthMenu(props) {
    const { itemList, changeFirstDepthMenu, isSubMenuOpen, toggleSubMenu, currentMenuInfo } = props;
    const { ServiceUnit_A } = usexAPI();

    const handleClick = (info) => {
        ServiceUnit_A(xAPI_ID_VALUE.serviceUnit.btn_menu_0002, getUrlPathnameAndSearch(info.MENU_URL));
        changeFirstDepthMenu(info);
        setXAPIPath("G");
    };

    const handleClickCloseButton = () => {
        toggleSubMenu();
    };

    return (
        <LogobarWrapper>
            <ButtonDropdown className="selectCustom3" isOpen={isSubMenuOpen} toggle={toggleSubMenu}>
                <DropdownToggle className="optionfirst" caret>
                    {currentMenuInfo.MENU_NAME}
                </DropdownToggle>
                <DropdownMenu className="optionlist">
                    {itemList
                        .filter((info) => info.MENU_CD !== gnbInfo.home)
                        .map((info, idx) => (
                            <DropdownItem
                                className={classnames({ oncolor: info.MENU_CD === currentMenuInfo.MENU_CD })}
                                key={idx}
                                onClick={() => handleClick(info)}
                            >
                                {info.MENU_NAME}
                            </DropdownItem>
                        ))}
                    <CloseButton handleClick={handleClickCloseButton} />
                </DropdownMenu>
            </ButtonDropdown>
        </LogobarWrapper>
    );
}

export default FirstDepthMenu;
